import { useEffect } from 'react';

import { logError, TAGS } from '@iwLogger/IwDataDogLogger';
import { Button } from '@iwoca/orion';
import { reloadCurrentLocation } from '@iwRouter/LocationHelper';
import { WarningTriangleSVG } from '@svgComponents/warningTriangleSVG';

function getCountryFromUrl() {
    if (typeof window === 'undefined') return false;

    const hostname = window.location.hostname;
    if (['www.iwoca.de', 'stage.iwoca-dev.de'].includes(hostname)) return 'DE';

    return 'UK';
}

export function ManuallyLocalisedFallbackError() {
    const isDE = getCountryFromUrl() === 'DE';

    useEffect(() => {
        if (isDE) {
            logError(`Fallback error UI shown`, {
                tags: TAGS.DE_LENDING
            });
        }
    }, [isDE]);

    return (
        <div
            className="p-xl text-center"
            data-testid="manually-localised-fallback-error"
        >
            <WarningTriangleSVG className="mx-auto" />
            <p className="font-bold">
                {isDE
                    ? 'Es sieht so aus, als wäre etwas schief gelaufen'
                    : 'Oops, it looks like something went wrong'}
            </p>
            <Button onClick={() => reloadCurrentLocation()}>
                {isDE ? 'Aktualisieren' : 'Refresh'}
            </Button>
        </div>
    );
}
